import classNames from 'classnames';
import { useAtomValue } from 'jotai';
import { observer } from 'mobx-react-lite';
import { useEffect, useMemo, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import DividerLeft from '@/assets/download/divider_left.webp';
import DividerRight from '@/assets/download/divider_right.webp';
import BlurryLoadingImage from '@/components/progressive-img';
import { recentlyGameWhiteList } from '@/constant/config';
import useEntrygame from '@/hooks/useEntryGame';
import { recentlyGameAtom } from '@/jotai/game';
import { gameStore } from '@/stores/game';
import globalStore from '@/stores/store';
import { getValidGame } from '@/utils/game';

import styles from './styles.module.less';

const RecommendGames = () => {
  const recentlyGame = useAtomValue(recentlyGameAtom);
  const navigate = useNavigate();
  const containerRef = useRef<HTMLDivElement>(null);
  const { showGame } = gameStore;
  const isScrollHandle = useRef(false);

  const games = useMemo(() => {
    // 过滤掉 API游戏
    const recentlyValidGame = recentlyGame?.filter(item => {
      return (
        !/^game\d+$/.test(item.pack) ||
        parseInt(item.pack.replace('game', '')) < 100 ||
        recentlyGameWhiteList.includes(item.pack) ||
        !!item.isCanRecommend
      );
    });
    const leftGameNum = 6 - (recentlyValidGame?.length || 0);

    const availableGames = getValidGame().filter(item => {
      return (
        !/^game\d+$/.test(item.pack) ||
        parseInt(item.pack.replace('game', '')) < 100 ||
        recentlyGameWhiteList.includes(item.pack) ||
        !!item.isCanRecommend
      );
    });
    const leftGames = availableGames
      .filter(item => {
        return !recentlyValidGame?.some(recentlyItem => recentlyItem.pack === item.pack);
      })
      .slice(0, leftGameNum);

    return (recentlyValidGame || []).concat(leftGames);
  }, [JSON.stringify(recentlyGame), showGame]);

  const { runEntry } = useEntrygame();

  useEffect(() => {
    if (containerRef.current) {
      if (containerRef.current.scrollLeft !== 0) {
        containerRef.current.scrollLeft = 0;
      }
    }
  }, []);

  const handleTouchStart = () => {
    isScrollHandle.current = false;
  };

  const handleTouchMove = () => {
    isScrollHandle.current = true;
  };

  const handleTouchEnd = (item: any, e) => {
    if (!isScrollHandle.current) {
      const { pack } = item;

      if (!globalStore.initialState.isLogin) {
        navigate('/login');
        return;
      }
      runEntry(pack);
    }
  };

  return (
    <>
      <div className={styles.top}>
        <BlurryLoadingImage loading="lazy" className={styles.divider} src={DividerLeft} alt="" />
        <div className={styles.content}>Most played</div>
        <BlurryLoadingImage loading="lazy" className={styles.divider} src={DividerRight} alt="" />
      </div>
      <div className={styles.main} ref={containerRef}>
        {games.map(item => (
          <div key={item.pack} className={styles.item} onClick={e => handleTouchEnd(item, e)}>
            <div
              className={classNames({
                [styles.item_tag]: item.isHot || item.isNew,
                [styles.item_tag_hot]: item.isHot,
                [styles.item_tag_new]: item.isNew
              })}
            >
              {item.isHot ? 'Hot' : ''}
              {item.isNew ? 'New' : ''}
            </div>
            {/* <img loading="lazy" src={item.img} alt="" /> */}
            <div className={styles.img} style={{ backgroundImage: `url(${item.img})` }}></div>
            {/* <div
              className={classNames({
                [styles.item_company]: !!item.company,
                [styles?.[item.company]]: true
              })}
            ></div> */}
          </div>
        ))}
      </div>
    </>
  );
};

export default observer(RecommendGames);
